import { ApiResponse } from '@marketplace-web/core-api/api-client-util'
import { api } from '@marketplace-web/core-api/core-api-client-util'
import { useApiGatewayClient } from '@marketplace-web/api-gateway/api-gateway-client-util'

import {
  GetConversationPhishingPassiveReminderResp,
  RemoveSafetyPassiveReminderResp,
  UpdateConversationPhishingPassiveReminderArgs,
} from '../types/phishing-passive-reminder'
import {
  GetSvcFirstTimeListerEducationStatusResp,
  RemoveFirstTimeListerEducationResp,
} from '../types/first-time-lister'
import { UserBlockArgs } from '../types/user-block'

export const getConversationPhishingPassiveReminder = (id: string) =>
  api.get<GetConversationPhishingPassiveReminderResp>(`msg_threads/${id}/safety_passive_reminder`)

export const updateConversationPhishingPassiveReminder = (
  id: string,
  args: UpdateConversationPhishingPassiveReminderArgs,
) => api.post<ApiResponse>(`msg_threads/${id}/safety_passive_reminder`, args)

export const markFirstTimeListerEducationAsRead = () =>
  api.delete('conversation_safety/education/first_time_listers')

export const blockUser = ({ currentUserId, blockedUserId }: UserBlockArgs) =>
  api.post(`/users/${currentUserId}/user_hates`, { hated_user_id: blockedUserId })

export const unblockUser = ({ currentUserId, blockedUserId }: UserBlockArgs) =>
  api.delete(`/users/${currentUserId}/user_hates`, { params: { hated_user_id: blockedUserId } })

export const useGetSvcConversationPhishingPassiveReminderGateway = () => {
  const apiGatewayClient = useApiGatewayClient()

  return (id: string) =>
    apiGatewayClient.get<GetConversationPhishingPassiveReminderResp>(
      `content-detection-tools/api/v1/phishing/educations/safety-passive-reminder/${id}/status`,
    )
}
export const useUpdateSvcConversationPhishingPassiveReminderGateway = () => {
  const apiGatewayClient = useApiGatewayClient()

  return (id: string) =>
    apiGatewayClient.post<RemoveSafetyPassiveReminderResp>(
      `content-detection-tools/api/v1/phishing/educations/safety-passive-reminder/${id}/disable`,
    )
}

export const useGetSvcFirstTimeListerEducationStatusGateway = () => {
  const apiGatewayClient = useApiGatewayClient()

  return (id: string) =>
    apiGatewayClient.get<GetSvcFirstTimeListerEducationStatusResp>(
      `content-detection-tools/api/v1/phishing/educations/first-time-lister/${id}/status`,
    )
}

export const useUpdateSvcFirstTimeListerEducationAsReadGateway = () => {
  const apiGatewayClient = useApiGatewayClient()

  return () =>
    apiGatewayClient.post<RemoveFirstTimeListerEducationResp>(
      'content-detection-tools/api/v1/phishing/educations/first-time-lister/disable',
    )
}
